import { useState } from 'react';
import styled from 'styled-components/macro';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useWindowSize } from 'hooks/useWindowSize';
import { BoxProps } from 'components/ui/Box';

interface DropdownItemProps {
  title: string;
  children: JSX.Element;
  breakpoint?: number;
}

const Wrapper = styled.div`
  position: relative;
`;

const Menu = styled.div`
  position: absolute;
  top: 50px;
  left: -16px;
  padding: 16px 0 16px 8px;
  background-color: #222;
  z-index: 2;

  a {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;

  span {
    margin-right: 8px;
  }
`;

const DropdownItem = ({ title, children, breakpoint }: DropdownItemProps & BoxProps) => {
  const ws = useWindowSize();
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(!open);

  const ref = useDetectClickOutside({
    onTriggered: () => setOpen(false),
  });

  if (breakpoint && ws.width < breakpoint) {
    return children;
  }

  return (
    <Wrapper ref={ref}>
      <Title onClick={toggleOpen}>
        <span>{title}</span>
        {open ? <FiChevronUp /> : <FiChevronDown />}
      </Title>
      {open && <Menu>{children}</Menu>}
    </Wrapper>
  );
};

export default DropdownItem;
